import { render } from "./LogDetailsModal.vue?vue&type=template&id=c88b473c&scoped=true"
import script from "./LogDetailsModal.vue?vue&type=script&lang=js"
export * from "./LogDetailsModal.vue?vue&type=script&lang=js"

import "./LogDetailsModal.vue?vue&type=style&index=0&id=c88b473c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c88b473c"]])

export default __exports__